import { Message } from 'dygc-ui'

const openMessage = (function () {
  let msg = null
  return function () {
    if (msg) return
    msg = Message({
      message: '禁止复制粘贴',
      type: 'warning',
      onClose: () => {
        msg = null
      }
    })
  }
})()

export default {
  methods: {
    onCopy(evt) {
      if (this.disableCopy) {
        evt.preventDefault()
        openMessage()
        return false
      }
    },
    onPaste(evt) {
      if (this.disableCopy) {
        evt.preventDefault()
        openMessage()
        return false
      }
    },
    onCut(evt) {
      if (this.disableCopy) {
        evt.preventDefault()
        openMessage()
        return false
      }
    }
  }
}
